import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a0d00] py-12 px-4" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-131">
          <div data-id="element-132">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-133">
              +3.000
            </div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-134">
              docentes confían
            </div>
          </div>
          <div data-id="element-135">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-136">12</div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-137">
              Tomos completamente listos
            </div>
          </div>
          <div data-id="element-138">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-139">
              4.9/5
            </div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-140">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-141">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-142">🇦🇷</div>
            <div className="text-[#FF6B00] text-sm font-semibold mt-1" data-id="element-143">
              Todo el país — primaria y secundaria
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-144">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-145">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-146">
              MG
            </div>
            <div data-id="element-147">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-148">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-149">
                "Organicé todo el año en una tarde"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-150">
                — Mariela G., Córdoba | Primaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-151">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-152">
              LP
            </div>
            <div data-id="element-153">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-154">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-155">
                "Mis clases de secundaria por fin enganchan"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-156">
                — Laura P., Rosario | Secundaria
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FF6B00]/20 rounded-xl p-4" data-id="element-157">
            <div className="w-10 h-10 rounded-full bg-[#FF6B00]/20 flex items-center justify-center text-[#FF6B00] font-black text-sm flex-shrink-0" data-id="element-158">
              RM
            </div>
            <div data-id="element-159">
              <div className="text-[#FF6B00] text-xs mb-1" data-id="element-160">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-161">
                "Nunca más llegué sin material a clase"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-162">
                — Roberto M., Buenos Aires | Primaria y Sec.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}